module.exports = __webpack_public_path__ + "static/media/yellow_nebula_FT.9ea77df8.png";